import '@/css/app.css'
import Alpine from 'alpinejs'
import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
import { runCookieScript } from './cookie-consent-mode.js'
// import './base/revealOnScroll.js'
import './base/parallax.js'
// import './base/heading-reveal.js'
import { initMaskTextScrollReveal } from './base/heading-reveal.js'
import { initContentRevealScroll } from './base/revealOnScroll.js'
import { initMenu } from './base/menu.js'
import { initLogoWallCycle } from './components/logoWall.js'
import { initLogoWallCycleTeam } from './components/logoWallTeam.js'
import { setHomeBannerCurrentState } from './components/homeBanner.js'
import { initDirectionalListHover } from './base/dir-hover.js'
import { initPreviewFollower } from './base/preview-hover.js'

import Lenis from 'lenis'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import barba from '@barba/core'

import { CustomEase } from 'gsap/CustomEase'

if (!window.Sprig) {
    window.Sprig = { components: [] }
}

gsap.registerPlugin(CustomEase, SplitText, ScrollTrigger)

CustomEase.create('loader', '0.65, 0.01, 0.05, 0.99')

const hasLenis = typeof window.Lenis !== 'undefined'
const hasScrollTrigger = typeof ScrollTrigger !== 'undefined'

const traceSplit = (label, extra = {}) => {
    const t = Math.round(performance.now())
    const fontStatus = document.fonts?.status || 'n/a'
    console.log(`[split-debug ${t}ms] ${label}`, {
        readyState: document.readyState,
        fontStatus,
        ...extra
    })
}

let Formie

const setFormieInstance = (instance) => {
    Formie = instance || window.Formie || null
}

document.addEventListener('onFormieLoaded', (event) => {
    setFormieInstance(event?.detail?.formie)
})

document.addEventListener('onFormieInit', (event) => {
    const formieInstance = event?.detail?.formie || window.Formie
    const formId = event?.detail?.formId
    const formElement = event?.detail?.$form

    setFormieInstance(formieInstance)

    if (
        formieInstance &&
        formId &&
        typeof formieInstance.refreshForCache === 'function'
    ) {
        formieInstance.refreshForCache(formId, (result) => {
            const jsCaptcha = result?.captchas?.javascript
            const sessionKey = jsCaptcha?.sessionKey
            const value = jsCaptcha?.value

            if (!sessionKey || !value) {
                return
            }

            // Barba does not execute inline scripts in fetched HTML.
            // Formie JS captcha expects this global variable to exist.
            window[`Formie${sessionKey}`] = value

            if (!formElement) {
                return
            }

            const placeholder = formElement.querySelector(
                '[data-jscaptcha-placeholder]'
            )

            if (!placeholder) {
                return
            }

            let input = placeholder.querySelector(`input[name="${sessionKey}"]`)

            if (!input) {
                input = document.createElement('input')
                input.setAttribute('type', 'hidden')
                input.setAttribute('name', sessionKey)
                placeholder.appendChild(input)
            }

            input.value = value
        })
    }
})

setFormieInstance(window.Formie)

const lenis = new Lenis({
    lerp: 0.165,
    wheelMultiplier: 1.25,
    // autoRaf: true,
    anchors: {
        offset: -50
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    }
})
window.lenis = lenis

if (hasScrollTrigger) {
    lenis.on('scroll', ScrollTrigger.update)
}

gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

// window.lenis = lenis

const headroom = () => {
    const headroom = new Headroom(document.querySelector('header'), {
        offset: 100,
        onTop: function () {
            document.querySelector('body').classList.add('headroom--top')
            document.querySelector('body').classList.remove('headroom--not-top')
        },

        onNotTop: function () {
            document.querySelector('body').classList.remove('headroom--top')
            document.querySelector('body').classList.add('headroom--not-top')
        }
    }).init()
}

const setHeaderTransitionState = (isTransitioning = false) => {
    const header = document.querySelector('header')
    if (!header) return

    header.classList.toggle('is-transitioning', isTransitioning)
}

// App main
const main = async () => {
    headroom()
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr',
        'homeBanner',
        'mediaSwiper',
        'projectsSwiper',
        'overviewFilter',
        'scrolledContent',
        'loadingTabs'
    ]
    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        const hasCompElements = compElements.length > 0

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                if (!hasCompElements) {
                    return
                }

                return Promise.all(
                    [...compElements].map((compElement) =>
                        init(compElement, lenis)
                    )
                )
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(initMenu())
    return await Promise.all(importPromises)
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}

// -----------------------------------------
// OSMO PAGE TRANSITION BOILERPLATE
// -----------------------------------------

const setManualScrollRestoration = () => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual'
    }
}

setManualScrollRestoration()
window.addEventListener('pageshow', setManualScrollRestoration)

// let lenis = null
let nextPage = document
let onceFunctionsInitialized = false
let htmxListenersInitialized = false

const rmMQ = window.matchMedia('(prefers-reduced-motion: reduce)')
let reducedMotion = rmMQ.matches
rmMQ.addEventListener?.('change', (e) => (reducedMotion = e.matches))
rmMQ.addListener?.((e) => (reducedMotion = e.matches))

const has = (s) => !!nextPage.querySelector(s)

let staggerDefault = 0.05
let durationDefault = 0.6

CustomEase.create('osmo', '0.625, 0.05, 0, 1')
gsap.defaults({ ease: 'osmo', duration: durationDefault })

function syncHtmxConfig() {
    if (window.htmx && window.htmx.config) {
        window.htmx.config.requestClass = 'loading'
    }
}

function initHtmxListeners() {
    if (htmxListenersInitialized) return
    if (!window.htmx || typeof window.htmx.on !== 'function') return

    htmxListenersInitialized = true

    window.htmx.on('htmx:afterSwap', (event) => {
        const target = event?.detail?.target
        if (!target || !target.matches?.('[data-sprig-scroll]')) return

        const offset = Number(target.dataset.sprigScrollOffset || -100)

        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            setTimeout(() => {
                window.lenis.scrollTo(target, { offset })
            }, 120)
            return
        }

        target.scrollIntoView({ block: 'start', behavior: 'smooth' })
    })
}

function primeFormieJsCaptchaGlobals(container) {
    if (!container) return

    const forms = container.querySelectorAll(
        'form[data-fui-form], div[data-fui-form]'
    )

    forms.forEach((formElement) => {
        const rawConfig = formElement.getAttribute('data-fui-form')

        if (!rawConfig) return

        try {
            const config = JSON.parse(rawConfig)
            const registeredJs = config?.registeredJs || []

            registeredJs.forEach((scriptConfig) => {
                if (scriptConfig?.module !== 'FormieJSCaptcha') return

                const sessionKey = scriptConfig?.settings?.sessionKey
                const value = scriptConfig?.settings?.value

                if (sessionKey && value) {
                    window[`Formie${sessionKey}`] = value
                }
            })
        } catch (error) {
            // Ignore invalid payloads - Formie will log config issues itself.
        }
    })
}

// -----------------------------------------
// FUNCTION REGISTRY
// -----------------------------------------

function initOnceFunctions() {
    if (onceFunctionsInitialized) return
    onceFunctionsInitialized = true

    syncHtmxConfig()
    initHtmxListeners()
    runCookieScript()
    // initLenis()
    // console.log('main then')

    main().then(() => {
        console.log('Vite <3')
        window.Alpine = Alpine

        Alpine.plugin(collapse)
        Alpine.start()
    })
    // initContentRevealScroll()

    // Runs once on first load
    // if (has('[data-something]')) initSomething();
}

function initBeforeEnterFunctions(next) {
    nextPage = next || document

    // Runs before the enter animation
    // if (has('[data-something]')) initSomething();

    // initMaskTextScrollReveal(next)
    // initContentRevealScroll(next)

    const hideOnTransitionElements = next.querySelectorAll(
        '[data-hide-on-transition]'
    )
    gsap.set(hideOnTransitionElements, {
        opacity: 0
    })
}

function initAfterEnterFunctions(next) {
    nextPage = next || document

    // Runs after enter animation completes
    // if (has('[data-something]')) initSomething();

    const hideOnTransitionElements = next.querySelectorAll(
        '[data-hide-on-transition]'
    )
    gsap.to(hideOnTransitionElements, {
        opacity: 1
    })

    initMaskTextScrollReveal(next)
    initContentRevealScroll(next)
    initLogoWallCycle(next)
    initLogoWallCycleTeam(next)
    initDirectionalListHover(next)
    initPreviewFollower(next)

    if (hasLenis) {
        lenis.resize()
    }
    if (hasScrollTrigger) {
        ScrollTrigger.refresh()
    }
}

// -----------------------------------------
// PAGE TRANSITIONS
// -----------------------------------------

async function runPageOnceAnimation(next) {
    traceSplit('once:start')
    setHomeBannerCurrentState(next, 0)
    await waitForWindowLoad()
    traceSplit('once:afterWindowLoad')
    await waitForInitialBannerLayout(next)
    traceSplit('once:afterInitialBannerLayout')

    const wrap = document.querySelector('[data-load-wrap]')
    if (!wrap) return

    const container = wrap.querySelector('[data-load-container]')
    const bg = wrap.querySelector('[data-load-bg]')
    // const progressBar = wrap.querySelector('[data-load-progress]')
    const logo = wrap.querySelector('[data-load-logo]')
    const textElements = Array.from(wrap.querySelectorAll('[data-load-text]'))

    // Reset targets that are * not * split text targets
    const resetTargets = Array.from(
        document.querySelectorAll('[data-load-reset]:not([data-load-text])')
    )

    const isHome = document
        .querySelector('body')
        .classList.contains('section-home')

    // Main loader timeline
    const loadTimeline = gsap.timeline({
        paused: true,
        defaults: {
            ease: 'loader',
            duration: 3
        }
    })
    loadTimeline
        .set(wrap, { display: 'block' })
        // .to(progressBar, { scaleX: 1 })
        .to(logo, { clipPath: 'inset(0% 0% 0% 0%)', duration: 2 }, '<')

        .to(container, { autoAlpha: 0, duration: 0.5 })

        .add('hideContent', '<')
        .add('startOnce', 'hideContent')
        .to(
            bg,
            { yPercent: -101, duration: isHome ? 1.2 : 1, ease: 'parallax' },
            'hideContent'
        )
        .set(wrap, { display: 'none' })

        .fromTo(
            next,
            {
                y: '100vh'
            },
            {
                y: '0vh',
                duration: 1,
                clearProps: 'all',
                ease: 'parallax'
            },
            'hideContent'
        )

    // If there are items to hide FOUC for, reset them at the start
    if (resetTargets.length) {
        loadTimeline.set(resetTargets, { autoAlpha: 1 }, 0)
    }

    traceSplit('once:beforeSplitReady')
    await waitForSplitTextReady()
    traceSplit('once:afterSplitReady')
    addBannerAnimations(loadTimeline, next, 'startOnce')
    traceSplit('once:afterAddBannerAnimations')
    loadTimeline.add('pageReady')

    resetPage(next)
    await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve))
    )
    loadTimeline.play(0)
    traceSplit('once:timelinePlay')

    return loadTimeline
}

async function waitForWindowLoad() {
    if (document.readyState === 'complete') return

    traceSplit('waitForWindowLoad:waiting')
    await new Promise((resolve) => {
        window.addEventListener('load', resolve, { once: true })
    })
    traceSplit('waitForWindowLoad:resolved')

    await new Promise((resolve) => requestAnimationFrame(resolve))
}

function runPageLeaveAnimation(current) {
    const transitionWrap = document.querySelector('[data-transition-wrap]')
    const transitionDark = transitionWrap.querySelector(
        '[data-transition-dark]'
    )

    const tl = gsap.timeline({
        onComplete: () => {
            current.remove()
        }
    })

    CustomEase.create('parallax', '0.7, 0.05, 0.13, 1')

    if (reducedMotion) {
        // Immediate swap behavior if user prefers reduced motion
        return tl.set(current, { autoAlpha: 0 })
    }

    tl.set(transitionWrap, {
        zIndex: 2
    })

    tl.fromTo(
        transitionDark,
        {
            autoAlpha: 0
        },
        {
            autoAlpha: 0.8,
            duration: 1.2,
            ease: 'parallax'
        },
        0
    )

    tl.fromTo(
        current,
        {
            y: '0vh'
        },
        {
            y: '-25vh',
            duration: 1.2,
            ease: 'parallax'
        },
        0
    )

    tl.set(transitionDark, {
        autoAlpha: 0
    })

    return tl
}

async function runPageEnterAnimation(next) {
    const tl = gsap.timeline()

    if (reducedMotion) {
        // Immediate swap behavior if user prefers reduced motion
        tl.set(next, { autoAlpha: 1 })
        tl.add('pageReady')
        tl.call(resetPage, [next], 'pageReady')
        return new Promise((resolve) => tl.call(resolve, null, 'pageReady'))
    }

    tl.add('startEnter', 0)

    tl.set(next, {
        zIndex: 3
    })

    tl.addLabel('startClip')
    tl.fromTo(
        next,
        {
            y: '100vh'
        },
        {
            y: '0vh',
            duration: 1.2,
            clearProps: 'all',
            ease: 'parallax'
        },
        'startEnter'
    )

    tl.add('pageReady')
    tl.call(resetPage, [next], 'pageReady')
    await waitForSplitTextReady()
    addBannerAnimations(tl, next, 'startClip')
    return new Promise((resolve) => {
        tl.call(resolve, null, 'pageReady')
    })
}

// -----------------------------------------
// BARBA HOOKS + INIT
// -----------------------------------------

barba.hooks.beforeEnter((data) => {
    // Position new container on top
    gsap.set(data.next.container, {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0
    })

    if (lenis && typeof lenis.stop === 'function') {
        lenis.stop()
    }

    initBeforeEnterFunctions(data.next.container)
    applyThemeFrom(data.next.container)
})

barba.hooks.before(() => {
    setHeaderTransitionState(true)
})

barba.hooks.beforeLeave(async (data) => {
    const { destroy: destroyFancybox } = await import(
        './components/fancybox.js'
    )
    destroyFancybox()

    if (data?.current?.container) {
        Alpine.destroyTree(data.current.container)
    }
    applyThemeFrom(data.next.container)
})

barba.hooks.afterLeave(() => {
    if (hasScrollTrigger) {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
})

barba.hooks.after(() => {
    if (lenis && typeof lenis.start === 'function') {
        lenis.start()
        lenis.resize()
    }
})

barba.hooks.enter((data) => {
    initBarbaNavUpdate(data)
})

barba.hooks.afterEnter((data) => {
    setHeaderTransitionState(false)

    // Run page functions
    initAfterEnterFunctions(data.next.container)

    lenis.resize()
    lenis.start()
    console.log('lenis.start()')

    if (hasScrollTrigger) {
        ScrollTrigger.refresh()
    }

    main().then(() => {
        Alpine.initTree(data.next.container)

        if (window.htmx && typeof window.htmx.process === 'function') {
            syncHtmxConfig()
            initHtmxListeners()
            window.htmx.process(data.next.container)
        }

        const hasFormieForms = data.next.container.querySelector(
            'form[data-fui-form], div[data-fui-form]'
        )
        const formieInstance = window.Formie || Formie

        if (
            hasFormieForms &&
            formieInstance &&
            typeof formieInstance.initForms === 'function'
        ) {
            primeFormieJsCaptchaGlobals(data.next.container)
            formieInstance.initForms()
        }
    })

    // ✅ FIX: hash terugzetten + ernaartoe scrollen
    const hash = getHashFromBarbaData(data)
    if (hash) {
        restoreHashInUrl(data)
        scrollToHash(hash, data.next.container)
    }
})

barba.init({
    debug: true, // Set to 'false' in production
    timeout: 7000,
    preventRunning: true,
    prevent: ({ el, href }) => {
        // if (!href) return false

        // const url = new URL(href, window.location.origin)

        // // zelfde pagina + hash => GEEN Barba transition
        // if (
        //     url.origin === window.location.origin &&
        //     url.pathname === window.location.pathname &&
        //     url.hash.length > 0
        // ) {
        //     return true
        // }

        // fancybox => GEEN Barba
        if (el?.closest('[data-fancybox]') || el?.closest('.fancybox')) {
            return true
        }

        return false
    },
    transitions: [
        {
            name: 'self',
            sync: true,

            // First load
            async once(data) {
                window.__homeBannerFromOnceAnimation = true
                initOnceFunctions()
                try {
                    return await runPageOnceAnimation(data.next.container)
                } finally {
                    window.__homeBannerFromOnceAnimation = false
                }
            },

            // Current page leaves
            async leave(data) {
                return runPageLeaveAnimation(data.current.container)
            },

            // New page enters
            async enter(data) {
                return runPageEnterAnimation(data.next.container)
            }
        },
        {
            name: 'default',
            sync: true,

            // First load
            async once(data) {
                window.__homeBannerFromOnceAnimation = true
                initOnceFunctions()
                try {
                    return await runPageOnceAnimation(data.next.container)
                } finally {
                    window.__homeBannerFromOnceAnimation = false
                }
            },

            // Current page leaves
            async leave(data) {
                return runPageLeaveAnimation(data.current.container)
            },

            // New page enters
            async enter(data) {
                return runPageEnterAnimation(data.next.container)
            }
        }
    ]
})

// -----------------------------------------
// GENERIC + HELPERS
// -----------------------------------------

const themeConfig = {
    white: {
        nav: 'white'
    },
    black: {
        nav: 'black'
    },
    transparent: {
        nav: 'transparent'
    }
}

function applyThemeFrom(container) {
    const pageTheme =
        container.querySelector('[data-page-theme]').dataset.pageTheme

    const config = themeConfig[pageTheme] || themeConfig.light
    console.log(config)
    document.body.dataset.pageTheme = pageTheme
    const wrapper = document.querySelector('[data-header-theme]')
    if (wrapper) {
        wrapper.dataset.headerTheme = config.nav
    }
}

function resetPage(container) {
    window.scrollTo(0, 0)
    // document.documentElement.scrollTop = 0
    // document.body.scrollTop = 0

    if (lenis && typeof lenis.scrollTo === 'function') {
        lenis.scrollTo(0, { immediate: true, force: true })
    }

    gsap.set(container, { clearProps: 'position,top,left,right' })

    lenis.resize()
    lenis.start()
}

function debounceOnWidthChange(fn, ms) {
    let last = innerWidth,
        timer
    return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => {
            if (innerWidth !== last) {
                last = innerWidth
                fn.apply(this, args)
            }
        }, ms)
    }
}

async function waitForInitialBannerLayout(container) {
    traceSplit('waitForInitialBannerLayout:start', {
        hasContainer: Boolean(container)
    })
    if (document.fonts && document.fonts.ready) {
        try {
            await document.fonts.ready
            traceSplit('waitForInitialBannerLayout:fontsReadyResolved')
        } catch (error) {
            console.warn(
                'Could not fully await font loading before banner split',
                error
            )
        }
    }
    await waitForStableBannerWidth(container)
    traceSplit('waitForInitialBannerLayout:stableWidthResolved')
}

async function waitForSplitTextReady() {
    if (!document.fonts) return

    traceSplit('waitForSplitTextReady:start')
    if (document.fonts.ready) {
        try {
            await document.fonts.ready
            traceSplit('waitForSplitTextReady:fontsReadyResolved')
        } catch (error) {
            // Ignore transient font loading failures and proceed.
        }
    }

    await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve))
    )
    traceSplit('waitForSplitTextReady:paintSettled')
}

async function waitForStableBannerWidth(
    container,
    stableFrames = 3,
    maxFrames = 30
) {
    const selectors = ['[data-banner-top]', '[data-banner-heading]']
    const elements = selectors
        .map((selector) => container?.querySelector?.(selector))
        .filter(Boolean)

    if (!elements.length) {
        await new Promise((resolve) => requestAnimationFrame(resolve))
        return
    }

    let previousWidths = elements.map((el) => el.getBoundingClientRect().width)
    let stableCount = 0

    for (let i = 0; i < maxFrames; i++) {
        await new Promise((resolve) => requestAnimationFrame(resolve))
        const currentWidths = elements.map(
            (el) => el.getBoundingClientRect().width
        )
        const isStable = currentWidths.every(
            (width, index) => Math.abs(width - previousWidths[index]) < 0.5
        )

        if (isStable) {
            stableCount += 1
            if (stableCount >= stableFrames) return
        } else {
            stableCount = 0
        }

        previousWidths = currentWidths
    }
}

function initBarbaNavUpdate(data) {
    var tpl = document.createElement('template')
    tpl.innerHTML = data.next.html.trim()

    var nextKeyedNodes = Array.from(
        tpl.content.querySelectorAll('[data-barba-update-key]')
    )
    var currentKeyedNodes = document.querySelectorAll('[data-barba-update-key]')

    currentKeyedNodes.forEach(function (curr) {
        var key = curr.getAttribute('data-barba-update-key')
        var next = nextKeyedNodes.find(function (node) {
            return node.getAttribute('data-barba-update-key') === key
        })

        if (!next) return

        var replacement = next.cloneNode(true)

        if (window.Alpine && typeof window.Alpine.destroyTree === 'function') {
            window.Alpine.destroyTree(curr)
        }

        curr.replaceWith(replacement)

        if (window.Alpine && typeof window.Alpine.initTree === 'function') {
            window.Alpine.initTree(replacement)
        }
    })

    var nextNodes = tpl.content.querySelectorAll('nav [data-barba-update]')
    var currentNodes = document.querySelectorAll('nav [data-barba-update]')

    currentNodes.forEach(function (curr, index) {
        var next = nextNodes[index]
        if (!next) return

        // Aria-current sync
        var newStatus = next.getAttribute('aria-current')
        if (newStatus !== null) {
            curr.setAttribute('aria-current', newStatus)
            if (newStatus == 'true') {
                curr.classList.add('active')
            } else {
                curr.classList.remove('active')
            }
        } else {
            curr.removeAttribute('aria-current')
        }

        // Class list sync
        var newClassList = next.getAttribute('class') || ''
        curr.setAttribute('class', newClassList)
    })
}

function getHashFromBarbaData(data) {
    // Beste bron: de aangeklikte link zelf
    const href = data?.trigger?.getAttribute?.('href') || ''
    const idx = href.indexOf('#')
    if (idx !== -1) return href.slice(idx) // bv "#scroll"
    // Fallback: huidige locatie (soms is hij er wel)
    return window.location.hash || ''
}

function restoreHashInUrl(data) {
    const href = data?.trigger?.href
    if (!href) return

    // Zet exact de href (incl. #hash) terug in de adresbalk
    // zonder extra navigation te triggeren.
    history.replaceState(history.state, '', href)
}

function scrollToHash(hash, container) {
    if (!hash) return

    // Zoek eerst in de nieuwe container (veiligste), dan global
    const el = container?.querySelector?.(hash) || document.querySelector(hash)

    if (!el) return

    // Wacht tot layout klaar is (zeker belangrijk met fixed container + GSAP)
    requestAnimationFrame(() => {
        if (lenis) {
            lenis.scrollTo(el, { offset: -50 })
        }
    })
}

// -----------------------------------------
// YOUR FUNCTIONS GO BELOW HERE
// -----------------------------------------

function addBannerAnimations(tl, container, startLabel) {
    if (!tl || !container) return
    const isOnceAnimation = startLabel === 'startOnce'
    traceSplit('addBannerAnimations:start', {
        startLabel,
        isOnceAnimation
    })

    const tagsTop = container.querySelector('[data-banner-tags]')
    if (tagsTop) {
        tl.from(
            tagsTop,
            {
                autoAlpha: 0,
                duration: 0.8
            },
            `${startLabel}+=0.6`
        )
    }

    const bannerTop = container.querySelector('[data-banner-top]')
    if (bannerTop) {
        traceSplit('addBannerAnimations:beforeSplitTop', {
            textLen: (bannerTop.textContent || '').trim().length
        })
        const headingTopSplit = SplitText.create(bannerTop, {
            type: 'lines',
            mask: 'lines', // wrap each line in an overflow:hidden div
            autoSplit: !isOnceAnimation,
            linesClass: 'line',
            wordsClass: 'word',
            charsClass: 'letter'
        })
        traceSplit('addBannerAnimations:afterSplitTop', {
            lines: headingTopSplit?.lines?.length || 0
        })

        tl.from(
            headingTopSplit.lines,
            {
                yPercent: 110,
                duration: 0.8,
                stagger: 0.08,
                ease: 'expo.out'
            },
            `${startLabel}+=0.6`
        )
    }

    const bannerHeading = container.querySelector('[data-banner-heading]')
    if (bannerHeading) {
        traceSplit('addBannerAnimations:beforeSplitHeading', {
            textLen: (bannerHeading.textContent || '').trim().length
        })
        const headingSplit = SplitText.create(bannerHeading, {
            type: 'lines',
            mask: 'lines', // wrap each line in an overflow:hidden div
            autoSplit: !isOnceAnimation,
            linesClass: 'line',
            wordsClass: 'word',
            charsClass: 'letter'
        })
        traceSplit('addBannerAnimations:afterSplitHeading', {
            lines: headingSplit?.lines?.length || 0
        })
        tl.from(
            headingSplit.lines,
            {
                yPercent: 110,
                duration: 0.8,
                stagger: 0.08,
                ease: 'expo.out'
            },
            `${startLabel}+=0.7`
        )
    }

    const bannerText = container.querySelectorAll('[data-banner-text]')
    if (bannerText) {
        tl.from(
            bannerText,
            {
                autoAlpha: 0,
                duration: 0.7
            },
            `${startLabel}+=0.7`
        )
    }
}
